import { Card, Collapse, FormLabel, Grid, MenuItem, Select } from "@mui/material";
import React, { useEffect, useMemo, useState } from "react";
import TranslationWrapper from "../../../components/TranslationWrapper/TranslationWrapper.tsx";
import CardBody from "../../../components/Card/CardBody";
import { convertArrayToSelectOptions } from "../../../templateHelpers";
import { contantBetalenTypes, mollieTransactionModes, payProvider } from "../../../variables/app";
import BlockedPaymentMethod from "../Modals/BlockedPaymentMethods";
import PayCommissions from "../Modals/PayCommissions";
import Gifty from "../PayProviderSec/Gifty";
import { useController, useForm, useFormContext, useWatch } from "react-hook-form";
import { _get } from "../../../http";
import FormSwitchTC from "../../../components/Forms/FormSwitchTC";
import FormTextTC from "../../../components/Forms/FormTextTC";
import FormSelectTC from "../../../components/Forms/FormSelectTC";
import FormAutocompleteTC from "../../../components/Forms/FormAutocompleteTC";
import AuthenticationWrapper from "../../../auth/AuthenticationWrapper";
import Button from "../../../components/CustomButtons/Button";
import Ccv from "../PayProviderSec/Ccv";
import Cikam from "../PayProviderSec/Cikam";
import Piggy from "../PayProviderSec/Piggy";
import JamezzPaymentsTransactionFees from "./JamezzPayments/JamezzPaymentsTransactionFees";
import JamezzPaymentsMethods from "./JamezzPayments/JamezzPaymentsMethods";
import FormCustomizableTextTC from "../../../components/Forms/FormCustomizableTextTC";
import GetList from "./Terminals/GetList";
import Dojo from "./Dojo";
import DojoEcommerce from "./DojoEcommerce";

function Primairbetallingsverkeer() {
  const contantBetalenTypes_options = useMemo(() => convertArrayToSelectOptions(contantBetalenTypes), []);
  const trans_mode_options = useMemo(() => convertArrayToSelectOptions(mollieTransactionModes), []);
  const { reloadDataFromServer, vestigingId } = useFormContext();
  const payProviderValue = useWatch({ name: "payProvider" });
  const allowMollieKeyValue = useWatch({ name: "allowMollieKey" });
  const payKeyValue = useWatch({ name: "payKey" });
  const tokenidValue = useWatch({ name: "tokenid" });
  const payCallValue = useWatch({ name: "payCall" });
  const paymentSettingsValue = useWatch({ name: "payment_settings" });
  const currencyValue = useWatch({ name: "currency" });
  const contantBetalen = useWatch({ name: "contantBetalen" });
  const appTarget = useWatch({ name: "appTarget" });

  const {
    field: { value: pay_provider_sec_typeValue, onChange: pay_provider_sec_typeOnChange },
    fieldState: { isDirty },
  } = useController({ name: "pay_provider_sec_type" });

  let {
    field: { value: payPinDeviceValue, onChange: payPinDeviceOnChange },
  } = useController({ name: "payPinDevice" });

  const [payProviderSecState, setPayProviderSecState] = useState(pay_provider_sec_typeValue);
  //const [payPinDevice, setPayPinDevice] = useState(payPinDevice);

  useEffect(() => {
    if (!isDirty) {
      setPayProviderSecState(pay_provider_sec_typeValue);
    } else {
      setPayProviderSecState("");
    }
  }, [pay_provider_sec_typeValue, isDirty]);

  const [payCommisionModal, setPayCommissionModal] = useState(false);
  const [blockedPaymentModal, setBlockedPaymentModal] = useState(false);
  const [showTerminals, setShowTerminals] = useState(false);
  const [terminalData, setTerminalData] = useState(null);
  const usePayAlliance = useWatch({ name: "custom_data.pay_alliance" });
  const mollieTransMode = useWatch({ name: "custom_data.mollie_trans_mode" });
  const availablePaymentProvidersValue = useWatch({ name: "availablePaymentProviders" });
  const availablePaymentProviders = useMemo(() => {
    return JSON.parse(availablePaymentProvidersValue ?? "[]");
  }, [availablePaymentProvidersValue]);

  const payProviderFilter = useMemo(() => {
    return payProvider.filter((value) => {
      return availablePaymentProviders.includes(value.value);
    });
  }, [availablePaymentProviders]);

  const payProviderOptions = useMemo(() => {
    return payProviderFilter;
  }, [payProviderFilter]);

  const payProviderSecOptions = useMemo(() => {
    return payProviderFilter
      .filter((item) => {
        return item.secundair;
      })
      .map((option) => ({ value: option.secundairValue, label: option.label }));
  }, [payProviderFilter]);
  const setupMerchantAccount = () => {
    _get("core/vestigingen/setupsplitt?type=merchant&vid=" + vestigingId, null, {
      showSpinner: true,
      showToastSuccess: true,
      showToastError: true,
    }).then(() => {
      reloadDataFromServer();
    });
  };

  const setupAdyenPlatforms = () => {
    _get("core/vestigingen/" + vestigingId + "/setupadyenplatforms", null, {
      showSpinner: true,
      showToastSuccess: true,
      showToastError: true,
    });
  };

  const payProviderTagList = payProvider.map((pay) => {
    return {
      value: pay.value,
      label: pay.label,
    };
  });

  const setupWebhook = () => {
    _get("core/vestigingen/setupsplitt?type=webhook&vid=" + vestigingId).then(() => {
      reloadDataFromServer();
    });
  };

  const setupWebhookStripe = () => {
    _get("core/vestigingen/setupwebhookstripe?vid=" + vestigingId).then(() => {
      reloadDataFromServer();
    });
  };

  const setupMollieOAuth = () => {
    const url = "core/oauth/get_authorize_uri?api=mollie&mode=" + mollieTransMode + "&vid=" + vestigingId;
    _get(url).then((result) => {
      window.location = result.data.data.redirectUri;
    });
  };

  const resetMollieOAuth = () => {
    const url = "core/oauth/reset_token?api=mollie&vid=" + vestigingId;
    _get(url).then((result) => {
      reloadDataFromServer();
    });
  };

  const getNewAccessTokenMollie = () => {
    const url = "core/oauth/update_access_token?api=mollie&vid=" + vestigingId;
    _get(url).then((result) => {});
  };

  const reloadPaymentProfiles = () => {
    const url = "core/vestigingen/reloadPaymentProfiles?api=mollie&vid=" + vestigingId;
    _get(url).then((result) => {
      window.location = window.location;
    });
  };

  const getMollieCardTerminals = () => {
    const url = "core/vestigingen/getCardTerminals?api=mollie&vid=" + vestigingId;
    _get(url).then((result) => {
      setTerminalData(result);
      setShowTerminals(true);
    });
  };

  const closeTerminalList = () => {
    setShowTerminals(false);
  };

  const selectTerminal = (terminalId) => {
    payPinDeviceOnChange({
      target: {
        value: terminalId,
      },
    });
    setShowTerminals(false);
  };

  return (
    <Grid container spacing={1}>
      <Grid item xs={12}>
        <Grid container spacing={1}>
          <Grid item xs={12}>
            {/*<Grid container item xs={12} lg={6} alignContent={"flex-start"}>*/}
            <Card>
              <CardBody>
                <Grid item xs={12}>
                  <h3>
                    <TranslationWrapper tDefault={"Algemeen"} tKey={"vestigingen.form.betalingen.headers.algemeen"} />
                  </h3>
                </Grid>
                <FormSwitchTC
                  name={"payDirect"}
                  tDefault={"Direct betalen"}
                  tKey={"vestigingen.form.primairbetallingsverkeer.label.payDirect"}
                />
                <FormSwitchTC
                  name={"opRekening"}
                  tDefault={"Betalen op rekening"}
                  tKey={"vestigingen.form.primairbetallingsverkeer.label.opRekening"}
                />
                <FormTextTC
                  name={"extra_settings__onAccountDescription"}
                  tDefault={"On account text"}
                  tKey={"vestigingen.form.primairbetallingsverkeer.label.onAccountDescription"}
                />
                <FormSwitchTC
                  name={"extra_settings__showCostCentre"}
                  tDefault={"Show cost centre"}
                  tKey={"vestigingen.form.primairbetallingsverkeer.label.showCostCentre"}
                />
                <FormSwitchTC
                  name={"contantBetalen"}
                  tDefault={"Contante betalingen"}
                  tKey={"vestigingen.form.primairbetallingsverkeer.label.contantBetalen"}
                />
                <Collapse in={Boolean(contantBetalen)} style={{ marginLeft: "16px", width: "100%" }}>
                  <FormSelectTC
                    name={"contantBetalenType"}
                    options={contantBetalenTypes_options}
                    tDefault={"Contant betalen type"}
                    tKey={"vestigingen.form.algemeen.label.contantBetalenType"}
                  />
                  {appTarget === "appv5.js" ? (
                    <FormCustomizableTextTC
                      model={"vestiging"}
                      modelId={vestigingId}
                      tDefault={"Translate cash payment text"}
                      tKey={"vestigingen.form.primairbetallingsverkeer.label.translateContant"}
                      translatableText={"Translate cash payment text in app"}
                    />
                  ) : (
                    <FormTextTC
                      name={"customTextPaymethodCash"}
                      tDefault={"Keuze tekst"}
                      tKey={"vestigingen.form.primairbetallingsverkeer.label.customTextPaymethodCash"}
                    />
                  )}
                </Collapse>
              </CardBody>
            </Card>
            {/*</Grid>*/}
          </Grid>
          <Grid item xs={12}>
            <Card>
              <CardBody>
                <FormSwitchTC
                  name={"memberCardBetalen"}
                  tDefault={"Membercard betalingen"}
                  tKey={"vestigingen.form.primairbetallingsverkeer.label.memberCardBetalen"}
                />
                <FormTextTC
                  name={"memberCardName"}
                  tDefault={"Membercard naam"}
                  tKey={"vestigingen.form.primairbetallingsverkeer.label.memberCardName"}
                />
                <FormSwitchTC
                  name={"ticketByMail"}
                  tDefault={"Rekening per mail"}
                  tKey={"vestigingen.form.primairbetallingsverkeer.label.ticketByMail"}
                />
                <FormSwitchTC
                  name={"fakePayments"}
                  tDefault={"Fake Payments"}
                  tKey={"vestigingen.form.primairbetallingsverkeer.label.fakePayments"}
                />
                <FormAutocompleteTC
                  multiple={true}
                  name={"availablePaymentProviders"}
                  options={payProviderTagList}
                  tDefault={"Beschikbare betalingproviders"}
                  tKey={"vestigingen.form.primairbetallingsverkeer.label.availablePaymentProviders"}
                />
              </CardBody>
            </Card>
          </Grid>
        </Grid>
      </Grid>
      <Grid item xs={12}>
        <Grid container spacing={1}>
          <Grid item xs={12}>
            <Card>
              <CardBody>
                <Grid item xs={12}>
                  <h3>
                    <TranslationWrapper tDefault={"Primair"} tKey={"vestigingen.form.betalingen.headers.primair"} />
                  </h3>
                </Grid>
                <FormAutocompleteTC
                  name={"payProvider"}
                  options={payProviderOptions}
                  tDefault={"PSP"}
                  tKey={"vestigingen.form.primairbetallingsverkeer.label.payProvider"}
                />
                {payProviderValue === "PAYNL" ? (
                  <FormSwitchTC
                    defaultValue={false}
                    name={"custom_data.pay_alliance"}
                    tDefault={"Pay Alliance Intergration"}
                    tKey={"vestigingen.pay_alliance"}
                  />
                ) : null}
                {payProviderValue === "DOJO" ? <Dojo /> : null}
                {payProviderValue === "DOJO-ECOMMERCE" ? <DojoEcommerce /> : null}

                {payProviderValue === "ADYEN" ? (
                  <FormCustomizableTextTC
                    model={"vestiging"}
                    modelId={vestigingId}
                    tDefault={"Translate online payment text"}
                    tKey={"vestigingen.form.primairbetallingsverkeer.label.translateOnline"}
                    translatableText={"Translate online payment text in app"}
                  />
                ) : null}
                {payProviderValue === "MOLLIE" && !allowMollieKeyValue ? (
                  <>
                    <FormSelectTC
                      name={"custom_data.mollie_trans_mode"}
                      options={trans_mode_options}
                      tDefault={"Transactie modus"}
                      tKey={"vestigingen.mollie_trans_mode"}
                    />
                    {mollieTransMode != null ? (
                      <Grid alignContent={"center"} item xs={12}>
                        {tokenidValue == null ? (
                          <Button color={"success"} onClick={setupMollieOAuth}>
                            <TranslationWrapper
                              tDefault={"Setup oAuth"}
                              tKey={"vestigingen.form.betalingen.mollie.oauth"}
                            />
                          </Button>
                        ) : (
                          <>
                            <Button color={"danger"} onClick={resetMollieOAuth}>
                              <TranslationWrapper
                                tDefault={"Reset oAuth"}
                                tKey={"vestigingen.form.betalingen.mollie.oauthreset"}
                              />
                            </Button>
                            <Button color={"success"} onClick={getNewAccessTokenMollie}>
                              <TranslationWrapper
                                tDefault={"Refresh access token"}
                                tKey={"vestigingen.form.betalingen.mollie.refreshtoken"}
                              />
                            </Button>
                            <Button color={"warning"} onClick={reloadPaymentProfiles}>
                              <TranslationWrapper
                                tDefault={"Reload payment profiles"}
                                tKey={"vestigingen.form.betalingen.mollie.loadprofiles"}
                              />
                            </Button>
                            {mollieTransMode == "OFFLINE" ? (
                              <Button color={"success"} onClick={getMollieCardTerminals}>
                                <TranslationWrapper
                                  tDefault={"Get card terminal list"}
                                  tKey={"vestigingen.form.betalingen.mollie.getTerminals"}
                                />
                              </Button>
                            ) : null}
                          </>
                        )}
                      </Grid>
                    ) : null}
                    {mollieTransMode == "OFFLINE" ? (
                      <FormTextTC
                        name={"payPinDevice"}
                        tDefault={"PIN Terminal ID"}
                        tKey={"vestigingen.form.primairbetallingsverkeer.label.payPinDevice"}
                        value={payPinDeviceValue}
                      />
                    ) : null}
                  </>
                ) : null}
                {(payProviderValue !== "MOLLIE" &&
                  payProviderValue !== "DOJO" &&
                  payProviderValue !== "DOJO-ECOMMERCE") ||
                allowMollieKeyValue ? (
                  <>
                    <FormTextTC
                      name={"payUser"}
                      tDefault={"Gebruiker"}
                      tKey={"vestigingen.form.primairbetallingsverkeer.label.payUser"}
                    />
                    {!usePayAlliance ? (
                      <>
                        <FormTextTC
                          name={"payKey"}
                          tDefault={"Key"}
                          tKey={"vestigingen.form.primairbetallingsverkeer.label.payKey"}
                        />
                        <FormTextTC
                          name={"tokenid"}
                          tDefault={"Token ID"}
                          tKey={"vestigingen.form.primairbetallingsverkeer.label.tokenid"}
                        />
                      </>
                    ) : null}
                    <FormTextTC
                      name={"payPinDevice"}
                      tDefault={"PIN Terminal"}
                      tKey={"vestigingen.form.primairbetallingsverkeer.label.payPinDevice"}
                    />
                    {payProviderValue === "PAYNL" ? (
                      <FormTextTC
                        name={"custom_data.pay_refund_terminal"}
                        tDefault={"PIN Terminal refunds"}
                        tKey={"vestigingen.form.primairbetallingsverkeer.label.custom_data.pay_refund_terminal"}
                      />
                    ) : null}
                    <FormTextTC
                      name={"payPinIP"}
                      tDefault={"PIN IP (local)"}
                      tKey={"vestigingen.form.primairbetallingsverkeer.label.payPinIP"}
                    />
                    <FormTextTC
                      name={"payPinPort"}
                      tDefault={"PIN Port (local)"}
                      tKey={"vestigingen.form.primairbetallingsverkeer.label.payPinPort"}
                    />
                    {payProviderValue === "ZVT" ? (
                      <FormTextTC
                        name={"custom_data.zvt.terminal_pin"}
                        tDefault={"ZVT Terminal pincode"}
                        tKey={"vestigingen.form.primairbetallingsverkeer.label.custom_data.zvt.terminal_pin"}
                      />
                    ) : null}
                    <FormTextTC
                      name={"apiaccounts__cardTermConfigServer"}
                      tDefault={"PIN Config server"}
                      tKey={"vestigingen.form.primairbetallingsverkeer.label.cardTermConfigServer"}
                    />
                    <FormTextTC
                      name={"apiaccounts__cardTermAuthServer"}
                      tDefault={"PIN auth server"}
                      tKey={"vestigingen.form.primairbetallingsverkeer.label.cardTermAuthServer"}
                    />
                    <FormTextTC
                      name={"payExtra"}
                      tDefault={"Extra Params"}
                      tKey={"vestigingen.form.primairbetallingsverkeer.label.payExtra"}
                    />
                    <FormTextTC
                      name={"payCall"}
                      tDefault={"PayCall Url"}
                      tKey={"vestigingen.form.primairbetallingsverkeer.label.payCall"}
                    />
                    <FormTextTC
                      name={"paymentCountry"}
                      tDefault={"Payment country"}
                      tKey={"vestigingen.form.primairbetallingsverkeer.label.payCountry"}
                    />
                    <FormTextTC
                      name={"payApiKey"}
                      tDefault={"Apikey"}
                      tKey={"vestigingen.form.primairbetallingsverkeer.label.payApiKey"}
                    />
                  </>
                ) : null}
                <FormSwitchTC
                  name={"testPayments"}
                  tDefault={"Test Payments"}
                  tKey={"vestigingen.form.primairbetallingsverkeer.label.testPayments"}
                />
                <FormSwitchTC
                  name={"fullPSPIntergration"}
                  tDefault={"Full PSP Intergration"}
                  tKey={"vestigingen.form.primairbetallingsverkeer.label.fullPSPIntergration"}
                />
                <FormTextTC
                  name={"appendPaymentString"}
                  tDefault={"Append payment"}
                  tKey={"vestigingen.form.primairbetallingsverkeer.label.appendPaymentString"}
                />
                <FormSwitchTC
                  defaultValue={false}
                  name={"custom_data.payments.print_customer_receipt"}
                  tDefault={"Print terminal customer receipt"}
                  tKey={"vestigingen.print_customer_receipt"}
                />
                <FormSwitchTC
                  defaultValue={false}
                  name={"custom_data.payments.print_merchant_receipt"}
                  tDefault={"Print terminal merchant receipt"}
                  tKey={"vestigingen.print_merchant_receipt"}
                />
                {payProviderValue === "ADYENPLATFORMS" ? (
                  <AuthenticationWrapper
                    child={
                      <>
                        <Grid item xs={12}>
                          <Button
                            color={"warning"}
                            onClick={() => {
                              setPayCommissionModal(true);
                            }}
                          >
                            <TranslationWrapper
                              tDefault={"Payment Commissions"}
                              tKey={"vestigingen.button.payCommissions"}
                            />
                          </Button>
                        </Grid>
                        <Grid item xs={12}>
                          <Button
                            color={"warning"}
                            onClick={() => {
                              setBlockedPaymentModal(true);
                            }}
                          >
                            <TranslationWrapper
                              tDefault={"Blocked payment methods"}
                              tKey={"vestigingen.button.blockedPaymentModal"}
                            />
                          </Button>
                        </Grid>
                        <Grid item xs={12}>
                          <Button color={"danger"} onClick={setupAdyenPlatforms}>
                            <TranslationWrapper
                              tDefault={"Setup adyen platforms"}
                              tKey={"vestigingen.button.setupadyenplatforms"}
                            />
                          </Button>
                        </Grid>
                      </>
                    }
                    permissionKey={"adyenplatforms"}
                  />
                ) : null}

                {payProviderValue === "SPLITT" ? (
                  <Grid item xs={12}>
                    {payKeyValue == null ? (
                      <Button color={"danger"} onClick={setupMerchantAccount}>
                        {tokenidValue === null ? "Create Merchants account" : "Get Merchants API key"}
                      </Button>
                    ) : null}

                    {payKeyValue != null && payCallValue == null ? (
                      <Button color={"danger"} onClick={setupWebhook}>
                        Setup webhook
                      </Button>
                    ) : null}
                  </Grid>
                ) : null}

                {payProviderValue === "STRIPE" && payKeyValue != null ? (
                  <Grid item xs={12}>
                    <Button color={"danger"} onClick={setupWebhookStripe}>
                      Setup webhook
                    </Button>
                  </Grid>
                ) : null}
              </CardBody>
            </Card>
          </Grid>

          <Grid item xs={12}>
            <Card>
              <CardBody>
                <Grid item xs={12}>
                  <h3>
                    <TranslationWrapper tDefault={"Secundair"} tKey={"vestigingen.form.betalingen.headers.secundair"} />
                  </h3>
                </Grid>
                <Grid item sm={4} xs={12}>
                  <FormLabel>
                    <TranslationWrapper
                      tDefault={"PSP"}
                      tKey={"vestigingen.form.primairbetallingsverkeer.label.payProvider"}
                    />
                  </FormLabel>
                </Grid>
                <Grid item sm={8} xs={12}>
                  <Select
                    onChange={(e) => {
                      pay_provider_sec_typeOnChange(e.target.value);
                    }}
                    style={{ width: "100%", backgroundColor: "rgba(100, 100, 100, 0.05)" }}
                    value={pay_provider_sec_typeValue ?? ""}
                  >
                    <MenuItem value={""}>
                      <TranslationWrapper
                        tDefault={"Geen betaal provider"}
                        tKey={"vestigingen.form.betallingsverkeer.optie.geenPayProvider"}
                      />
                    </MenuItem>
                    {payProviderSecOptions.map((option) => (
                      <MenuItem key={option.value} value={option.value}>
                        {option.label}
                      </MenuItem>
                    ))}
                  </Select>
                </Grid>
                {payProviderSecState === "Ccv" ? <Ccv /> : null}
                {payProviderSecState === "Cikam" ? <Cikam /> : null}
                {payProviderSecState === "Gifty" ? <Gifty /> : null}
                {payProviderSecState === "Piggy" ? <Piggy /> : null}
              </CardBody>
            </Card>
          </Grid>
          {(payProviderValue === "MOLLIE" && tokenidValue != null && !allowMollieKeyValue) ||
          payProviderValue === "CM" ||
          usePayAlliance ? (
            <>
              {paymentSettingsValue != undefined && paymentSettingsValue.settings != null ? (
                <Grid item xs={12}>
                  <Card>
                    <CardBody>
                      <Grid item xs={12}>
                        <h3>
                          <TranslationWrapper
                            tDefault={"Payment settings"}
                            tKey={"vestigingen.form.betalingen.headers.paymentsettings"}
                          />
                        </h3>
                      </Grid>
                      <Grid item xs={12}>
                        <JamezzPaymentsMethods
                          paymentSettings={paymentSettingsValue}
                          reloadDataFromServer={reloadDataFromServer}
                        />
                      </Grid>
                    </CardBody>
                  </Card>
                </Grid>
              ) : null}

              <Grid item xs={12}>
                <Card>
                  <CardBody>
                    <Grid item xs={12}>
                      <h3>
                        <TranslationWrapper
                          tDefault={"Transaction fees"}
                          tKey={"vestigingen.form.betalingen.headers.transacionfees"}
                        />
                      </h3>
                    </Grid>
                    <Grid item xs={12}>
                      <JamezzPaymentsTransactionFees currency={currencyValue} paymentSettings={paymentSettingsValue} />
                    </Grid>
                  </CardBody>
                </Card>
              </Grid>
            </>
          ) : null}
        </Grid>
      </Grid>
      <GetList
        closeTerminalList={closeTerminalList}
        open={showTerminals}
        selectTerminal={selectTerminal}
        terminalList={terminalData}
      />
      {payCommisionModal ? (
        <PayCommissions
          open={payCommisionModal}
          toggle={() => setPayCommissionModal(!payCommisionModal)}
          vestiging_id={vestigingId}
        />
      ) : null}

      {blockedPaymentModal ? (
        <BlockedPaymentMethod
          open={blockedPaymentModal}
          toggle={() => setBlockedPaymentModal(!blockedPaymentModal)}
          vestiging_id={vestigingId}
        />
      ) : null}
    </Grid>
  );
}

export default Primairbetallingsverkeer;
